import React, { useState } from 'react';
import { FaSearch, FaFilter, FaSort } from 'react-icons/fa';
import './flashcard_browser.css';

function FlashcardBrowser({ isDarkMode }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDeck, setSelectedDeck] = useState('all');
  const [selectedChapter, setSelectedChapter] = useState('all');
  const [sortBy, setSortBy] = useState('date');

  // # Handle search
  const handleSearch = (e) => {
    e.preventDefault();
    // TODO: Implement search functionality
  };

  // # Handle filter changes
  const handleDeckChange = (e) => {
    setSelectedDeck(e.target.value);
    // TODO: Implement deck filtering
  };

  const handleChapterChange = (e) => {
    setSelectedChapter(e.target.value);
    // TODO: Implement chapter filtering
  };

  // # Handle sort change
  const handleSortChange = (e) => {
    setSortBy(e.target.value);
    // TODO: Implement sorting
  };

  return (
    <div className="flsh_brws_content">
      {/* Search bar */}
      <div className="flsh_brws_search-section">
        <form onSubmit={handleSearch} className="flsh_brws_search-form">
          <div className="flsh_brws_search-input-wrapper">
            <FaSearch className="flsh_brws_search-icon" />
            <input
              type="text"
              placeholder="Search flashcards..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="flsh_brws_search-input"
            />
          </div>
          <button type="submit" className="flsh_brws_search-button">
            Search
          </button>
        </form>
      </div>

      {/* Filters */}
      <div className="flsh_brws_filters-section">
        <div className="flsh_brws_filter-group">
          <FaFilter className="flsh_brws_filter-icon" />
          <select 
            value={selectedDeck} 
            onChange={handleDeckChange}
            className="flsh_brws_filter-select"
          >
            <option value="all">All Decks</option>
            <option value="step1">USMLE Step 1</option>
            <option value="step2">USMLE Step 2</option>
          </select>

          <select 
            value={selectedChapter} 
            onChange={handleChapterChange}
            className="flsh_brws_filter-select"
          >
            <option value="all">All Chapters</option>
            <option value="biochemistry">Biochemistry</option>
            <option value="anatomy">Anatomy</option>
            {/* Add more chapter options */}
          </select>
        </div>

        <div className="flsh_brws_sort-group">
          <FaSort className="flsh_brws_sort-icon" />
          <select 
            value={sortBy} 
            onChange={handleSortChange}
            className="flsh_brws_filter-select"
          >
            <option value="date">Date Created</option>
            <option value="name">Name</option>
            <option value="difficulty">Difficulty</option>
            <option value="lastReviewed">Last Reviewed</option>
          </select>
        </div>
      </div>

      {/* Results */}
      <div className="flsh_brws_results-section">
        <div className="flsh_brws_results-header">
          <h3>Search Results</h3>
          <span>0 cards found</span>
        </div>

        <div className="flsh_brws_results-grid">
          {/* Placeholder for flashcard results */}
          <div className="flsh_brws_no-results">
            <FaSearch className="flsh_brws_no-results-icon" />
            <p>No flashcards found. Try adjusting your search or filters.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FlashcardBrowser; 